export default __webpack_public_path__ + "static/media/mosaic-logo-icon-colorful.57ae1da0.svg";